import { Grid } from '@mui/material'
import Item from 'pages/dashboard/sub-sections/items'
import { SanitizedTextField } from './SanitizedTextField'

interface ContractDetailsFieldsProps {
  numberValue: string
  nameValue: string
  onNumberChange: (value: string) => void
  onNameChange: (value: string) => void
  onNumberError?: (hasError: boolean) => void
  onNameError?: (hasError: boolean) => void
  numberError?: boolean
  nameError?: boolean
  numberHelperText?: string
  nameHelperText?: string
}

/**
 * Reusable Contract Details Fields component
 * Combines Contract Number and Contract Name fields
 */
export const ContractDetailsFields = ({
  numberValue,
  nameValue,
  onNumberChange,
  onNameChange,
  onNumberError,
  onNameError,
  numberError = false,
  nameError = false,
  numberHelperText = '',
  nameHelperText = ''
}: ContractDetailsFieldsProps) => {
  return (
    <Grid container sx={{ marginBottom: '10px' }} spacing={2}>
      <Grid item xs={3.94}>
        <Item>
          <SanitizedTextField
            InputLabelProps={{ shrink: true }}
            label="Contract Number (Optional)"
            placeholder="Enter Contract Number (Optional)"
            id="number"
            name="number"
            type="text"
            autoComplete="off"
            onChange={onNumberChange}
            value={numberValue}
            error={numberError}
            helperText={numberHelperText}
            onSanitizationError={onNumberError}
            maxLength={1000}
          />
        </Item>
      </Grid>

      <Grid item xs={1} />

      <Grid item xs={4.06}>
        <Item>
          <SanitizedTextField
            InputLabelProps={{ shrink: true }}
            label="Contract Name (Optional)"
            name="name"
            id="name"
            type="text"
            autoComplete="off"
            placeholder="Enter Contract Name (Optional)"
            value={nameValue}
            onChange={onNameChange}
            error={nameError}
            helperText={nameHelperText}
            onSanitizationError={onNameError}
            maxLength={500}
          />
        </Item>
      </Grid>
    </Grid>
  )
}

export default ContractDetailsFields
